var path = './admin/exportUsersButtonTooltip.html';
var html = "<div ng-bind-html=\"getUserExportDisabledReason() !== null ? getUserExportDisabledReason() : ('ADMIN.CONTENT_PARTIAL.DOWNLOAD_USER_LIST_TOOLTIP'|translate)\" ng-click=\"markCompanionAsInstalled()\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;